module.exports = __webpack_public_path__ + "img/mbBanner1.319d6c1c.png";